<main role="main" class="page-Chantiers-infrastructures not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" [routerLink]="['/']">Accueil</a></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)"
                [routerLink]="['/grands-chantiers/chantiers-infrastructures']">Grands chantiers</a></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)"
                [routerLink]="['/grands-chantiers/chantiers-infrastructures']">Chantiers infrastructures</a></li>
            <li class="breadcrumb-item active">{{Chantier.Port | translate}}</li>
          </ol>
        </nav>
        <p class="text-primary size18 font-weight-semibold">{{Chantier.Port | translate}}</p>
        <h2>{{Chantier.Titre}}</h2>
      </div>
    </div>
    <div class="row">
      <img [src]="Chantier.ImageUrl" alt="Project Picture" width="100%" style="max-height: 500px;">

    </div>
    <div id="content"></div>
  </div>
  <section class="c-section-full">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2>Autres chantiers</h2>
          <div class="card-slider" id="slider-chantier1">
            <ol>
              <div class="card-slider-item col-md-4" *ngFor="let Chantier of Chantiers">
                <div class="card"><a href="javascript:void(0)"
                    [routerLink]="['/grands-chantiers/chantiers-infrastructures',Chantier.Id]"><img class="card-img-top"
                      [src]="Chantier.PortImage" width="387" height="188" alt="...">
                    <div class="card-body">
                      <h3 class="card-title">{{Chantier.Titre}}</h3>
                      <span class="text-primary port-name">{{Chantier.Port | translate}}</span>
                    </div>
                  </a></div>
              </div>
            </ol>
          </div>
          <a class="btn btn-info pr-5" style="margin-left:50%;" href="javascript:void(0)"
            [routerLink]="['/grands-chantiers/chantiers-infrastructures']">Afficher tout<span
              class="icon-cheveron-right"></span></a>
        </div>
      </div>
    </div>
  </section>
</main>